<template>
    <div>
      <div style="overflow-x:auto;">
        <div
          class="heatmap-grid"
          :style="{ gridTemplateColumns: '60px repeat(24, 30px)',
          maxWidth: '100%',
          margin: '0 auto' }"
        >
          <!-- Header kiri kosong -->
          <div></div>
          <!-- Jam -->
          <div v-for="h in 24" :key="'h'+h" class="heatmap-label">
            {{ String(h - 1).padStart(2, '0') }}
          </div>
  
          <!-- Setiap baris hari -->
          <template v-for="(hari, i) in days">
            <div :key="hari" class="heatmap-label">{{ hari }}</div>
            <div
              v-for="j in 24"
              :key="hari + '-' + j"
              class="heatmap-cell"
              
              :style="{ background: getColor((data[i] && data[i][j - 1]) ? data[i][j - 1] : 0) }"
              :title="tooltipTitle(i, j-1)"
              @click="cellClick(i, j-1)"
              @mouseenter="hoverCell = hari + '-' + j"
              @mouseleave="hoverCell = null"
              :class="{ 'heatmap-hover': hoverCell === (hari + '-' + j) }"
            ></div>
          </template>
        </div>
      </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'HeatmapGrid',
    props: {
        data: {type: Array, default: () => [] },
        default: () => Array(7).fill().map(()=>Array(24).fill(0))
    },
    data() {
      return {
        days: ['Min','Sen','Sel','Rab','Kam','Jum','Sab'],
        // Contoh data: Array 7x23, angka 0-5
        // data: this.data,
        hoverCell: null,
      }
    },
    methods: {
      getColor(val) {
        // Kategori warna
        if (val < 25)        return '#11F1F5';
        else if (val < 50)   return '#0FDAF3';
        else if (val < 75)  return '#0DC3F2';
        else if (val < 100)  return '#0CADF0';
        else if (val < 125)  return '#0A96EE';
        else if (val < 150)  return '#087FED';
        else if (val < 175)  return '#0668EB';
        else if (val < 200)  return '#0552E9';
        else if (val < 300)  return '#033BE8';
        else                 return '#0124E6';
      },
      tooltipTitle(i, j) {
        // Tampilkan info hari, jam, nilai
        const jam = j < 10 ? '0'+j : j;
        // const value = this.data[i][j] || 0;
        const value = (this.data[i] && this.data[i][j] !== undefined) ? this.data[i][j] : 0;
        return `Hari: ${this.days[i]}\nJam: ${jam}:00\nAktivitas: ${value}`
      },
      cellClick(i, j) {
        // di klik muncul alert
        const jam = j < 10 ? '0'+j : j
        alert(
          `Hari: ${this.days[i]}\nJam: ${jam}:00\nAktivitas: ${this.data[i][j] || 0}`
        )
      }
    }
  }
  </script>
  
  <style scoped>
  .heatmap-grid {
    display: grid;
    grid-gap: 10px;
    margin-bottom: 12px;
  }
  .heatmap-label {
    font-size: 13px;
    text-align: center;
    color: #8da4b6;
    align-self: center;
    font-weight: 500;
  }
  .heatmap-cell {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    transition: background .2s, box-shadow .2s;
    cursor: pointer;
  }
  .heatmap-cell.heatmap-hover {
    box-shadow: 0 0 0 2px #4096ee99;
    z-index: 2;
    position: relative;
    outline: 1px solid #4096ee66;
  }
  </style>
  